import React, { useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { StackNavigationProp } from '@react-navigation/stack';

import {
    DETAIL_ERROR_CANCEL,
    DETAIL_ERROR_DESCRIPTION,
    DETAIL_ERROR_TITLE,
} from 'config/testID';

import { SCREEN } from 'router/screens';
import { RouteNavigationParams } from 'router/types';

import { selectLayoutConfig } from 'store/config/selectors';

import isFunction from 'utils/function';
import { isWeb } from 'utils/responsiveness';

import styles from 'screens/Detail/components/DetailPageButtons/styles';
import {
    OK_BUTTON,
    SUSPENSION_VOD_LIMIT_REACHED_DESCRIPTION,
    SUSPENSION_VOD_LIMIT_REACHED_TITLE,
} from 'screens/Detail/languageConst';

import dialogStyles from 'components/Dialog/style';
import ErrorDialog from 'components/ErrorDialog';

type Props = {
    navigation?: StackNavigationProp<
        RouteNavigationParams,
        SCREEN.DETAILS_VOD_HIGH_USAGE_RESTRICTION
    >;
    onClose?(): void;
};

function DetailVodHighUsageRestriction({ navigation, onClose }: Props) {
    const { primary } = useSelector(selectLayoutConfig);
    const { t } = useTranslation();

    const handleClose = useCallback(() => {
        if (isWeb && navigation && navigation.canGoBack()) {
            navigation.goBack();
        } else if (isFunction(onClose)) {
            onClose();
        } else {
            navigation?.reset({
                routes: [{ name: SCREEN.ROOT }],
            });
        }
    }, [navigation, onClose]);

    return (
        <ErrorDialog
            style={[styles.errorDialog, dialogStyles.nonTransparentDialog]}
            title={SUSPENSION_VOD_LIMIT_REACHED_TITLE}
            description={SUSPENSION_VOD_LIMIT_REACHED_DESCRIPTION}
            descriptionNumberOfLines={10}
            actionButtonTitle={OK_BUTTON}
            actionButtonAccessibilityLabel={t(OK_BUTTON)}
            actionButtonFillColor={primary}
            actionButtonTextStyle={styles.errorButtonText}
            actionButtonOnPress={handleClose}
            titleTestID={DETAIL_ERROR_TITLE}
            descriptionTestID={DETAIL_ERROR_DESCRIPTION}
            actionButtonTestID={DETAIL_ERROR_CANCEL}
        />
    );
}

export default DetailVodHighUsageRestriction;
